export enum UserTypes {
  'Musician' = 'Musician',
  'Seeker' = 'Seeker',
}
